//MainSubBeforeLawsuit
import { useEffect, useRef, useState } from 'react';
import { Space, Select, Input, Button, Collapse, Checkbox, Modal, Typography, Divider, Row, Col, DatePicker, Card, Transfer, Table, Flex, Switch, Tag, List, message, notification, Spin, Layout } from 'antd';
import { CaretRightOutlined, CheckOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { mockContracts } from './MockData';
import ModalAddBeforeLawsuit from '../modals/ModalAddBeforeLawsuit';
import Map from '../../../services/Map';
import MapRoutes from '../../../services/MapRoutes';
import axios from 'axios';
import MotionHoc from '../../../../utils/MotionHoc';
import ModalAddBeforeLawsuitforProvince from '../modals/ModalAddBeforeLawsuitforProvince';
import { getProvince } from '../../../services/TextMap';
import { POST_LOAD_MAIN_INVESTIGATION } from '../../../API/apiUrls';
import { Autocomplete, DirectionsRenderer, DirectionsService, GoogleMap, InfoWindowF, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import styled from "styled-components";

const { Panel } = Collapse;
const { Text, Title } = Typography;
const { Option } = Select;
const libraries = ['places', 'marker'];

function MainSubBeforeLawsuit(props) {
    const [api, contextHolder] = notification.useNotification();
    const [filterProvince, setFilterProvince] = useState(null); // จังหวัด
    const [optionProvince, setOptionProvince] = useState([]); // จังหวัด
    const [filterDistrict, setFilterDistrict] = useState(null); // อำเภอ
    const [filterContractId, setFilterContractId] = useState(""); // เลขสัญญา
    const [isModalGoogleMap, setIsModalGoogleMap] = useState(false);
    const [isModalGoogleMapRoute, setIsModalGoogleMapRoute] = useState(false);
    const [dataSendForMap, setDataSendForMap] = useState('') // map ตาม lat,lng
    const [dataSendForMapRoute, setDataSendForMapRoute] = useState('') // map ตาม lat,lng (หลายสถานที่)
    const [searchResult, setSearchResult] = useState([]);

    const [searchMessage, setSearchMessage] = useState(''); // state เก็บข้อความ
    const [loading, setLoading] = useState(false)
    const [dataBeforeLawsuit, setDataBeforeLawsuit] = useState([]); // ค้นหาข้อมูลสัญญาที่ตรงกับเงื่อนไข
    const [searchData, setSearchData] = useState([]); // ค้นหาข้อมูลสัญญาที่ตรงกับเงื่อนไข
    const [dataBackUp, setDataBackUp] = useState([]); // ค้นหาข้อมูลสัญญาที่ตรงกับเงื่อนไข
    const [openModal, setOpenModal] = useState(false);
    const [openModalforProvince, setOpenModalforProvince] = useState(false);
    const [reloadData, setReloadData] = useState(false);
    const [selectedDistrict, setSelectedDistrict] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState([]);
    const [dataAllProvince, setDataAllProvince] = useState([]);
    const [province, setProvince] = useState([]);
    const { isLoaded, loadError } = useJsApiLoader({ // โหลด google map
        id: 'script-loader',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: libraries, // ต้องใส่เพื่อใช้ AdvancedMarkerElement
        language: 'th',
        region: 'TH',
        version: 'weekly',
    });

    useEffect(() => {
        loadDataBeforeLawsuit();
    }, [reloadData])

    // console.log("searchData", searchData);
    // console.log("reloadData", reloadData);
    // console.log("dataBeforeLawsuit", dataBeforeLawsuit);
    // console.log("filterProvince", filterProvince);
    // console.log("dataAllProvince", dataAllProvince);
    // console.log("filterContractId", filterContractId);
    // console.log("searchResult", searchResult);
    // console.log("dataBackUp", dataBackUp);

    const StyledSearch = styled(Input.Search)`
        .ant-input {
            height: 40px;
            line-height: 40px;
        }

        .ant-input-search-button {
            height: 40px;
        }
    `;

    const handleChangDataForReturn = (data) => {
        // console.log("data", data);
        setReloadData((prev) => !prev);
    }

    const loadDataBeforeLawsuit = async () => {
        setLoading(true)
        const params = {
            province: filterProvince || "",
            district: filterDistrict || "",
            contno: filterContractId || "",
            userId: 888 || null,
            typeCase: "normal" || ""
        }
        try {

            const response = await axios.post(POST_LOAD_MAIN_INVESTIGATION,
                params, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
                },
            })

            console.log("response loadDataBeforeLawsuit", response?.data);
            if (response?.data) {
                // ดึงเฉพาะ province และกรองค่าซ้ำ / null / undefined
                setDataAllProvince(response?.data)
                let province = response.data.filter(province => {
                    const matchProvince = province.province;
                    return matchProvince;
                });

                console.log("province", province);
                setOptionProvince(province)


                let filtered = response.data.filter(contract => {
                    const matchProvince = filterProvince ? contract.provinceName === filterProvince : true;
                    const matchDistrict = filterDistrict ? contract.districtName === filterDistrict : true;
                    const matchContno = filterContractId ? contract.contno.includes(filterContractId) : true;
                    return matchProvince && matchDistrict && matchContno;
                });

                // console.log("filtered", filtered);
                // group เป็น province -> district -> contracts
                const groupedResult = filtered.reduce((acc, item) => {
                    const provinceName = item.provinceName; // แปลง code → ชื่อ
                    if (!acc[provinceName]) acc[provinceName] = {};
                    if (!acc[provinceName][item.districtName]) acc[provinceName][item.districtName] = [];
                    acc[provinceName][item.districtName].push(item);
                    return acc;
                    // if (!acc[item.province]) acc[item.province] = {};
                    // if (!acc[item.province][item.district]) acc[item.province][item.district] = [];
                    // acc[item.province][item.district].push(item);
                    // return acc;
                }, {});
                console.log("groupedResult", groupedResult);

                setSearchData(groupedResult);
                setDataBackUp(groupedResult);
                setDataBeforeLawsuit(groupedResult)
                setReloadData(false)
                setLoading(false)
            } else {
                api.message("โหลดข้อมูลไม่สำเร็จ")
                setLoading(false)
            }
        } catch {
            console.error("❌ API Error:");
            api.error({
                message: 'เกิดข้อผิดพลาด',
                placement: 'top',
            });
            setLoading(false)
        }
    }

    const handleOpenModal = (contracts) => {
        setSelectedDistrict(contracts);
        setOpenModal(true);
    };
    const handleOpenModalforProvince = (district, province) => {
        setSelectedProvince(district);
        setProvince(province);
        setOpenModalforProvince(true);
    };

    const columns = [
        {
            title: 'ชื่อ',
            align: 'center',
            render: (value) => {
                return (
                    <>
                        {value ?
                            <div style={{ textAlign: 'start' }}>
                                {value?.SNAM}  {value?.NAME1}  {value?.NAME2}
                            </div>
                            :
                            null
                        }
                    </>
                )
            }
        },
        {
            title: 'ที่อยู่',
            dataIndex: 'asset',
            key: 'asset',
            align: 'center',
            render: (addresses) => {
                if (!addresses || addresses.length === 0) return null;

                return (
                    <div style={{
                        // display: 'flex',
                        flexDirection: 'column',
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: '8px'
                    }}
                    >
                        {addresses.map((addr, idx) => {
                            const addressText = addr ?
                                <>
                                    {addr?.numberLand ? addr?.numberLand : ''}
                                    {addr?.numberLandlawang ? addr?.numberLandlawang : ''}
                                    {addr?.district ? addr?.district : ''}
                                    {addr?.subdistrict ? addr?.subdistrict : ''}
                                    {addr?.zipcode ? addr?.zipcode : ''}
                                </>
                                :
                                addr.address;

                            const lat = addr.lat || null;
                            const lng = addr.lng || null;

                            return (
                                <div key={idx} style={{ border: '1px solid #f0f0f0', padding: '4px', borderRadius: '4px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span>{addressText}</span>
                                    {/* {lat && lng && ( */}
                                    <Button
                                        type="primary"
                                        icon={<EnvironmentOutlined />}
                                        onClick={() => {
                                            setIsModalGoogleMap(true)
                                            setDataSendForMap(addr)
                                        }}
                                    >
                                        {/* เปิด Google Maps */}
                                    </Button>
                                    {/* )} */}
                                </div>
                            );
                        })}
                    </div>
                );
            }
        },
        {
            title: 'เบอร์โทร',
            dataIndex: 'phone',
            key: 'phone',
            align: 'center',
        },
        {
            title: 'เกี่ยวข้องกับสัญญา',
            dataIndex: 'role',
            key: 'role',
            align: 'center',
            render: (record) => {
                return (
                    <>
                        <div style={{ textAlign: 'start' }}>
                            {record === 0 ? <>คนกู้</> : <>คนค้ำ {record}</>}
                        </div>
                    </>
                )
            }
        },
        {
            title: 'สถานะสืบออนไลน์',
            dataIndex: 'investigation',
            key: 'investigation',
            align: 'center',
            render: (value) => (value ? 'เจอ' : 'ไม่เจอ')
        },
        {
            title: 'เส้นทางการเดินทาง',
            align: 'center',
            render: (recods, index) => {
                // ✅ ถ้ามี asset น้อยกว่า 2 ไม่ต้องแสดงปุ่ม
                if (!recods?.asset || recods.asset.length < 2) {
                    return null;
                }

                return (
                    <Button
                        type="primary"
                        onClick={() => {
                            setIsModalGoogleMapRoute(true);
                            setDataSendForMapRoute(recods.asset);
                        }}
                    >
                        เปิด Google Maps
                    </Button>
                );
            }
        },
    ]

    const onSave = async (status, data) => {
        console.log("status", status);
        console.log("data", data);
        if (status === "OK") {
            const { landId, lat, lng, nameMap } = data;

            setSearchData((prev) => {
                const updated = { ...prev };

                // loop province
                Object.keys(updated).forEach((province) => {
                    // loop district
                    Object.keys(updated[province]).forEach((district) => {
                        updated[province][district] = updated[province][district].map((loan) => {
                            return {
                                ...loan,
                                customerList: loan.customerList.map((cust) => ({
                                    ...cust,
                                    asset: cust.asset.map((a) =>
                                        a.landId === landId
                                            ? {
                                                ...a,
                                                lat,
                                                lng,
                                                nameMap, // ✅ เพิ่ม/อัปเดตชื่อที่อยู่
                                            }
                                            : a
                                    ),
                                })),
                            };
                        });
                    });
                });

                return updated;
            });

            setIsModalGoogleMap(false);
        }
    }

    // tranFormData
    const transformData = (data) => {
        let provinceName = null;
        // หา province จากข้อมูลชุดแรกที่เจอ
        for (const district in data) {
            if (data[district].length > 0 && data[district][0].province) {
                provinceName = data[district][0].province;
                break;
            }
        }

        if (!getProvince(provinceName)) {
            return data; // ถ้าไม่มี province ให้คืนข้อมูลเดิม
        }
        console.log("provinceName", provinceName);

        // สร้าง object ใหม่ โดยมี province เป็น key รอบนอก
        return {
            [getProvince(provinceName)]: data
        };
    };

    // -------------- Input Search -------------- //
    const handleSearch = (contNo) => {
        const matchedProvinces = {};

        for (const provinceName in searchData) {
            const districts = searchData[provinceName];
            for (const districtName in districts) {
                const contracts = districts[districtName];
                const found = contracts.find((item) => item.contno === contNo);
                if (found) {
                    matchedProvinces[provinceName] = dataBackUp[provinceName];
                    break; // เจอแล้วข้ามไปจังหวัดถัดไป
                }
            }
        }
        if (!filterContractId) {
            setSearchData(dataBackUp);
        }

        if (Object.keys(matchedProvinces).length > 0) {
            console.log("matchedProvinces", matchedProvinces);
            setSearchResult(matchedProvinces);
            setSearchData(matchedProvinces);
        } else {
            setSearchResult(null);
            setSearchData(dataBackUp);
        }
    };



    const onChanSelectProvince = (province) => {
        // console.log("province+++++++++", province);
        setFilterProvince(province);
        setFilterDistrict(null);

        let results = [];
        let result = [];

        if (province === "all") {
            // 👉 รวมทุกจังหวัดเข้าด้วยกัน
            results = dataBeforeLawsuit;

            // ถ้ามีหลายจังหวัด ก็สามารถ wrap ทีหลังได้
            result = results;
        } else if (province && dataBeforeLawsuit[province]) {
            // 👉 ถ้าเลือกจังหวัดเดียว
            if (filterDistrict && dataBeforeLawsuit[province][filterDistrict]) {
                results = dataBeforeLawsuit[province][filterDistrict];
            } else {
                results = dataBeforeLawsuit[province];
            }

            // wrap จังหวัดให้เป็น key รอบนอก
            result = transformData(results);
        }

        console.log("result", result);
        setSearchData(result);
    };

    // search
    const selectSearch = () => {
        const provinceOptions = [
            ...new Set(optionProvince.map(c => c.province).filter(p => p))
        ].map(prov => ({
            value: getProvince(prov),
            label: getProvince(prov)
        }));

        // เพิ่มตัวเลือก "ทั้งหมด" ไว้ด้านบน
        const allOption = {
            value: "all",
            label: "ทั้งหมด"
        };

        const finalOptions = [allOption, ...provinceOptions];

        return finalOptions.map(opt => (
            <Option key={opt.value} value={opt.value}>
                {opt.label}
            </Option>
        ));
    };

    // สร้าง option อำเภอจากจังหวัดที่เลือก
    const districtOptions = filterProvince
        ? [
            { value: '', label: 'ทั้งหมด' }, // เพิ่ม option "ทั้งหมด" ค่าเป็น empty string
            ...[...new Set(
                mockContracts
                    .filter((c) => c.province === filterProvince)
                    .map((c) => c.district)
            )].map((dist) => ({
                value: dist,
                label: dist
            }))
        ]
        : [];

    return (
        <Row
            style={{
                maxWidth: "100%",
                margin: "auto",
                padding: "24px 12px",
                background: "#ffffff",
                // borderRadius: 8,
                // boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Spin spinning={loading} tip="Loading..." size="large">
                <Title level={3} style={{ textAlign: 'center', marginBottom: 24 }}>
                    ค้นหาสัญญาและเลือกฝ่ายที่เกี่ยวข้อง
                </Title>

                {/* Filter Section with responsive grid */}
                <Row
                    gutter={[16, 16]}
                    justify="center"
                    style={{ marginBottom: 24 }}
                >
                    <Col xs={24} sm={6}>
                        <Select
                            showSearch
                            value={filterProvince}
                            onChange={(val) => onChanSelectProvince(val)}
                            style={{ width: "100%", height: 40 }}
                            placeholder="เลือกจังหวัด"

                        >
                            {selectSearch()}
                        </Select>
                    </Col>
                    <Col xs={24} sm={6}>
                        <Select
                            showSearch
                            value={filterDistrict}
                            onChange={setFilterDistrict}
                            style={{ width: "100%", height: 40 }}
                            options={districtOptions}
                            placeholder="เลือกอำเภอ"
                            disabled={!filterProvince}
                            allowClear
                        />
                    </Col>
                    <Col xs={24} sm={6} >
                        <StyledSearch
                            value={filterContractId}
                            onChange={(e) => setFilterContractId(e.target.value)}
                            onSearch={handleSearch}   // กดปุ่ม Enter หรือ "ค้นหา"
                            placeholder="ค้นหาเลขสัญญา"
                            enterButton="ค้นหา"
                            style={{ width: "100%" }}
                            autoFocus // เพิ่มตรงนี้
                        />
                    </Col>
                </Row>
                <Row
                    justify="center"
                    style={{ marginBottom: 24, height: '700px' }}
                >
                    {/* Contracts List */}
                    {searchData && (
                        <div style={{ flex: 1, maxHeight: 650, overflowY: "auto" }}>
                            <Collapse
                                accordion
                                expandIconPosition="start" // เอา icon มาวางซ้าย
                                expandIcon={({ isActive }) => (
                                    <CaretRightOutlined
                                        style={{
                                            fontSize: '24px',
                                            color: '#5e6317',
                                            transition: 'transform 0.2s',
                                            transform: isActive ? 'rotate(90deg)' : 'rotate(0deg)',
                                            lineHeight: '60px', // ให้สูงเท่ากับ header
                                            marginTop: '20px'
                                        }}
                                    />
                                )}
                            >
                                {Object.entries(searchData).map(([province, districts]) => (
                                    <Panel
                                        key={province}
                                        header={
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    width: '100%',
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                }}
                                            >
                                                <span>{province}</span>
                                                <Button
                                                    size="small"
                                                    style={{
                                                        background: '#f3c600ff',

                                                    }}
                                                    onClick={e => {
                                                        // console.log("e", e);
                                                        // console.log("province++++++++++++", province);
                                                        // console.log("districts+++++++++++", districts);
                                                        e.stopPropagation(); // ป้องกันการเปิด/ปิด collapse
                                                        handleOpenModalforProvince(districts, province);
                                                    }}
                                                >
                                                    ลงวันลงพื้นที่หลายอำเภอ
                                                </Button>
                                            </div>
                                        }
                                    >

                                        <Collapse accordion
                                            expandIconPosition="start" // เอา icon มาวางซ้าย
                                            expandIcon={({ isActive }) => (
                                                <CaretRightOutlined
                                                    style={{
                                                        fontSize: '24px',
                                                        color: '#5e6317',
                                                        transition: 'transform 0.2s',
                                                        transform: isActive ? 'rotate(90deg)' : 'rotate(0deg)',
                                                        lineHeight: '60px', // ให้สูงเท่ากับ header
                                                        marginTop: '20px'
                                                    }}
                                                />
                                            )}
                                        >
                                            {Object.entries(districts).map(([district, contracts]) => (
                                                <Panel
                                                    key={district}
                                                    header={
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between',
                                                                width: '100%',
                                                                // height: '60px',
                                                                fontSize: '16px',
                                                                fontWeight: '500',
                                                                // padding: '0 16px',
                                                            }}
                                                        >
                                                            <span>{district}</span>
                                                            <Button
                                                                size="small"
                                                                style={{ background: '#5e6317ff', color: 'white' }}
                                                                onClick={e => {
                                                                    e.stopPropagation(); // ป้องกันการเปิด/ปิด collapse
                                                                    handleOpenModal(contracts);
                                                                }}
                                                            >
                                                                ลงวันลงพื้นที่
                                                            </Button>
                                                        </div>
                                                    }
                                                >
                                                    <Row>
                                                        <Col span={24}>
                                                            <List
                                                                dataSource={contracts}
                                                                renderItem={contract => (
                                                                    <List.Item style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                                                                        <div style={{ marginBottom: 8 }}>
                                                                            <strong>สัญญา: {contract.contno}</strong> | วันที่: {contract.date}
                                                                        </div>
                                                                        <Table
                                                                            style={{ width: '100%' }}
                                                                            dataSource={contract.customerList}
                                                                            rowKey={(party) => party.name} // ใช้ name เป็น key หรือใช้ field ที่ unique
                                                                            pagination={false} // ปิด pagination เพราะมีแค่ 3 parties
                                                                            bordered
                                                                            size="small"
                                                                            columns={columns}
                                                                        />

                                                                    </List.Item>
                                                                )}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Panel>
                                            ))}
                                        </Collapse>
                                    </Panel>
                                ))
                                }
                            </Collapse>
                        </div>
                    )
                    }
                </Row>

            </Spin>
            {/* Modal */}
            {
                openModalforProvince ?
                    <ModalAddBeforeLawsuitforProvince
                        open={openModalforProvince}
                        close={setOpenModalforProvince}
                        // selectedProvince={selectedProvince}
                        province={province}
                        dataAllProvince={dataAllProvince}
                        handleChangDataForReturn={handleChangDataForReturn}
                    />
                    : null
            }
            {
                openModal ?
                    <ModalAddBeforeLawsuit
                        open={openModal}
                        close={setOpenModal}
                        selectedDistrict={selectedDistrict}
                        handleChangDataForReturn={handleChangDataForReturn}
                    />
                    : null
            }
            {
                isModalGoogleMap ?
                    <Map
                        open={isModalGoogleMap}
                        close={setIsModalGoogleMap}
                        onSave={onSave}
                        dataSendForMap={dataSendForMap}
                        isLoaded={isLoaded}
                    />
                    : null
            }
            {
                isModalGoogleMapRoute ?
                    <MapRoutes
                        open={isModalGoogleMapRoute}
                        close={setIsModalGoogleMapRoute}
                        onSave={(data) => console.log("ตำแหน่งที่เลือก:", data)}
                        dataSendForMapRoute={dataSendForMapRoute}
                        isLoaded={isLoaded}
                        loadError={loadError}
                    />
                    : null
            }
            {contextHolder}
        </Row>
    );
}
const MainSubBeforeLawsuits = MotionHoc(MainSubBeforeLawsuit);
export default MainSubBeforeLawsuits;